import React, { PropTypes } from 'react'
import range from 'lodash/range'
import styles from './index.css'

export default function Pagination (props) {
  const { total, current, width } = props
  const binWidth = Math.floor(width / 2)

  if (total <= 1) { return null }

  let numbers

  if (current <= binWidth) {
    numbers = range(1, width < total ? width + 1 : total + 1)
  } else if (current > binWidth && current < total - binWidth) {
    numbers = range(current - binWidth, current + binWidth + 1)
  } else {
    numbers = range(width < total ? total - width + 1 : 1, total + 1)
  }

  return (
    <div className={ styles.root }>
      <div className={ styles.content }>
        {
          numbers.map(item => (
            <div
              key={ item }
              className={ item === current ? styles.itemActive : styles.item }
              onClick={ () => handleChange(props, item) } >
                { item }
            </div>
          ))
        }
      </div>
      <div className={ styles.nav }>
        <i className="icon-arrow-more" onClick={ () => handleChange(props, current - 1) } />
        <i className="icon-arrow-more" onClick={ () => handleChange(props, current + 1) } />
      </div>
    </div>
  )
}

function handleChange (props, to) {
  if (to === props.current || to > props.total || to < 1) { return }

  props.onChange(to)
}

Pagination.propTypes = {
  total: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
  width: PropTypes.number,
  onChange: PropTypes.func.isRequired
}

Pagination.defaultProps = {
  width: 5
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/Pagination/index.js
 **/